<template>
  <ul>
    <li>Antal anmälda {{ currentPeriod }}: {{ numberOfSignedupMembers }}</li>
    <li>Antal betalda medlemsavgifter {{ currentYear }}: {{ numberOfPaidMembershipFees }}</li>
    <li>Antal betalda träningsavgifter {{ currentPeriod }}: {{ numberOfPaidWorkoutFees }}</li>
  </ul>
</template>

<script>
  export default {
    props: {
      members: Array
    },
    computed: {
      numberOfSignedupMembers() {
        return this.members.filter(m => m.signups && m.signups.includes(this.currentPeriod)).length
      },
      numberOfPaidMembershipFees() {
        return this.members.filter(m => this.membershipPaid(m.fees)).length
      },
      numberOfPaidWorkoutFees() {
        return this.members.filter(m => this.workoutPaid(m.fees)).length
      }
    },
    data() {
      return {
        currentPeriod: 'ht-2026',
        currentYear: '2026'
      }
    },
    methods: {
      membershipPaid(fees) {
        return (fees && fees.filter(f => f.type === 'membership' && f.year === this.currentYear).length > 0);
      },
      workoutPaid(fees) {
        return (fees && fees.filter(f => f.period === this.currentPeriod && f.type.startsWith('workout-')).length > 0);
      }
    }
  }

</script>
